import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileSettingService } from "../../services/profile-setting.service";

export const getProfileSetting = createAsyncThunk(
  "profileSettingManage/getProfileSetting",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await profileSettingService.getProfileSetting();

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const syncProfileSetting = createAsyncThunk(
  "profileSettingManage/syncProfileSetting",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await profileSettingService.syncProfileSetting();

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
